export const toLowerCase = (s: string) => s.toLowerCase();
export const normalizeCase = (s: string) => s.normalize("NFKD").replace(/[\u0300-\u036F]/g, "");
